import { ScrollUpButton } from '@radix-ui/react-select';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import { Icon } from '@/shared/ui/icon';
import './select.scss';

type Props = ComponentPropsWithoutRef<typeof ScrollUpButton>;
export const SelectScrollUpButton = ({ className, ...props }: Props) => {
    return (
        <ScrollUpButton
            data-testid="select-scroll-up-button"
            className={cn('select__scroll-button', className)}
            {...props}
        >
            <Icon name="chevron-right" />
        </ScrollUpButton>
    );
};
